module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "thehistoryof03"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Initially, the length of service for nobles was undetermined, and they often served for life. In 1736, new regulations allowed nobles to keep one son at home to take care of the family property; other male children could study until the age of 20 when they had to enlist in the army for 25 years. They were usually registered at age seven and called to St. Petersburg at 16, where they would undergo a knowledge examination. Well-educated nobles could choose civil careers while others continued their studies until the age of 20, when they were called to the Heraldry (geroldia) to begin military service. Nobles who did not receive education by 16 were enlisted in the navy and unable to receive an officer’s rank.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e46afc10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/therussian_thehistoryof03.vue
// module id = 102
// module chunks = 0